import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[900],
        borderTop: '1px solid',
        borderColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[300]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="body2" color="text.secondary" align="center">
          Built overnight by{' '}
          <Link
            href="https://www.linkedin.com/in/VaiMan"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            sx={{ textDecoration: 'underline' }}
          >
            VaiMan
          </Link>{' '}
          &{' '}
          <Link
            href="https://www.linkedin.com/in/rishabh-raj-9217762b8/"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            sx={{ textDecoration: 'underline' }}
          >
            TheOdinStudent
          </Link>{' '}
          💀
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 